import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { BRAND_NAME, destinations, taveuniThingsToDoUrl } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Discover() {
  return <section id="taveuni" className="w-full bg-ivory py-24 sm:py-28 lg:py-36" data-id="element-24" data-mp="3dqc0wjixim2k">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-25" data-mp="3io3v5k71qk9x">
        <Reveal className="max-w-3xl" data-id="element-26" data-mp="a7itkogqutgu">
          <SectionLabel data-id="element-27" data-mp="a8k50u1o9hz3">The Island</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-28" data-mp="f7ezit904uz1">
            Discover Taveuni
          </h2>
          <p className="mt-4 font-serif text-2xl italic text-ocean" data-id="element-29" data-mp="bp7add83llv">
            The Garden Island of Fiji.
          </p>
          <p className="mt-6 text-[16px] leading-[1.85] text-forest-deep/65" data-id="element-30" data-mp="2kztub8izy2ke">
            From lush rainforests and waterfalls to beautiful coastlines and
            world-class diving, Taveuni offers a unique combination of adventure,
            nature, and island life.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-31" data-mp="1e4pybrqu8l39">
          <div className="mt-10 flex max-w-3xl items-start gap-4 rounded-[1.5rem] border border-gold/40 bg-sand-light px-7 py-6" data-id="element-32" data-mp="1e5hsqz8p8cry">
            <MapPin className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold" strokeWidth={1.4} aria-hidden="true" data-id="element-33" data-mp="1s5iqw6xkx63q" />
            <p className="text-[15px] leading-[1.8] text-forest-deep/75" data-id="element-34" data-mp="221dhbo81o5h2">
              <span className="font-semibold text-forest-deep" data-id="element-35" data-mp="1x3kf169v3vm2">
                A strategic base on the island.
              </span>{' '}
              Staying at {BRAND_NAME} places you close to Taveuni's main
              attractions — waterfalls, rainforest trails, coastal walks,
              beaches and world-class dive sites are all within easy reach, so
              you spend less time travelling and more time exploring.
            </p>
          </div>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-6" data-id="element-36" data-mp="1dgdyih771fgb">
          {destinations.map((destination, i) => <Reveal as="li" key={destination.title} delay={i * 0.07} className={i < 2 ? 'lg:col-span-3' : 'lg:col-span-2'} data-id="element-37" data-mp="1hh7odg4754bu" data-mpi={i}>
              <article className="group relative h-full overflow-hidden rounded-[1.75rem] bg-forest-deep" data-id="element-38" data-mp="1r829gh5phxvp">
                <img src={destination.image} alt={destination.alt} loading="lazy" decoding="async" sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw" className={`w-full object-cover opacity-90 transition-all duration-[1200ms] ease-calm group-hover:scale-[1.06] group-hover:opacity-100 ${i < 2 ? 'h-[380px] lg:h-[440px]' : 'h-[340px] lg:h-[400px]'}`} data-id="element-39" data-mp="1w5tzt6qpdbxs" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/25 to-transparent" data-id="element-40" data-mp="fsvrbat6klef" />
                <div className="absolute inset-x-0 bottom-0 p-7" data-id="element-41" data-mp="8axmhjly1yhj">
                  <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory" data-id="element-42" data-mp="3gtdkut4bgdt">
                    {destination.title}
                  </h3>
                  <p className="mt-2.5 max-w-sm text-[14px] leading-relaxed text-ivory/75" data-id="element-43" data-mp="3pq4awmor3qh7">
                    {destination.description}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold-soft" data-id="element-44" data-mp="r5w0oi6iu1fp">
                    Explore
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 ease-calm group-hover:translate-x-1.5" aria-hidden="true" data-id="element-45" data-mp="h87vszf7bdjt" />
                  </span>
                </div>
                <a href={taveuniThingsToDoUrl} target="_blank" rel="noopener noreferrer" className="absolute inset-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label={`Explore ${destination.title} on Tourism Fiji`} data-id="element-46" data-mp="2xyoj8e8c7dk4" />
              </article>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}